// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 11/2/2023 2:09:59 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

export enum PayPeriodStatusTypeEnum {
  notDefined = 0,
  created = 1,
  waitingDataEntry = 2,
  payPeriodViewed = 3,
  calculateTaxes = 4,
  calculateTaxesCompleted = 5,
  submitted = 6,
  submitProcessed = 7,
  waitingSubmit = 8,
  waitingApproval = 9,
  waitingSubmitOrApproval = 10,
  approved = 11,
  approvalProcessed = 12,
  workmansCompCalculated = 13,
  fieldAccountMaintenance = 14,
  journalCreated = 15,
  invoiceCreated = 16,
  reportsCreated = 17,
  moneyMovementProcessed = 18,
  undoRequested = 19,
  nextPayPeriodCreated = 20,
  forceClosedRequested = 21,
  forceClosed = 22,
  deleteRequested = 23,
  deleted = 24,
  skipRequested = 25,
  skipped = 26,
  stopDepositInitiated = 27,
  stopDepostProcessingComplete = 28,
  journalSynchronized = 29,
  postingJournalReportCreated = 30,
}

export enum PayrollActionTypeEnum {
  notDefined = 0,
  noActionNeeded = 1,
  createPayPeriod = 2,
  openForDataEntry = 3,
  dataEntryInProgress = 4,
  submit = 5,
  approve = 6,
  approveProcessing = 7,
  withdrawCompanyFunds = 8,
  depositEmployeeFunds = 9,
  processFinal = 10,
  close = 11,
  forceClose = 12,
  delete = 13,
  submitProcessing = 14,
  setWaitingSubmitOrApprove = 15,
  skip = 16,
  waitingApproval = 17,
  rollback = 18,
  createNextPayPeriod = 19,
  createPayrollRegister = 20,
  createJournal = 21,
  synchronizeJournal = 22,
  createInvoice = 23,
  maintainFieldAccount = 24,
  calculateTaxes = 25,
  calculateWorkmansComp = 26,
  stopDeposit = 27,
  createReports = 28,
  createMoneyMovement = 29,
  createPostingJournalReports = 30,
}

export enum PayrollTypeEnum {
  notDefined = 0,
  salaried = 1,
  hourly = 2,
}

export enum PayrollFrequencyTypeEnum {
  notDefined = 0,
  weekly = 1,
  biweekly = 2,
  monthly = 3,
  everyFourWeeks = 4,
  quarterly = 5,
  semiMonthly = 6,
  custom = 7,
}

export enum PayPeriodTemplateTypeEnum {
  notDefined = 0,
  standardThreeDay = 1,
  standardFourDay = 2,
  standardFiveDay = 3,
  custom = 4,
  standardOneDay = 5,
  standardTwoDay = 6,
  standardSevenDay = 7,
}

export enum WorkbookTypeEnum {
  notDefined = 0,
  employees = 1,
  employeeDetail = 2,
  canadaTaxes = 3,
  canadaTaxesEdit = 4,
  canadaStatPay = 5,
  usTaxes = 6,
  usTaxesEdit = 7,
  reviewAndApprove = 8,
  gridEdit = 9,
}

export enum FrequencyTypeEnum {
  notDefined = 0,
  oneTime = 1,
  everytime = 2,
  lastOfMonth = 3,
  firstOfMonth = 4,
  customPeriodFlags = 5,
}

export enum DataValueTypeEnum {
  notDefined = 0,
  amount = 1,
  percentage = 2,
}

export enum PayPeriodCycleTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  firstOfMonth = 2,
  lastOfMonth = 3,
  offCycle = 4,
}

export enum PayGroupStatusTypeEnum {
  notDefined = 0,
  active = 1,
  deleted = 2,
  disabled = 3,
  incomplete = 4,
}

export enum PayGroupFrequencyTypeEnum {
  notDefined = 0,
  weekly = 1,
  biweekly = 2,
  semimonthly = 3,
  monthly = 4,
  quarterly = 5,
}

export enum PayPeriodCalendarStateTypeEnum {
  notDefined = 0,
  completed = 1,
  processing = 2,
  current = 3,
  upcoming = 4,
  skipped = 5,
}

export enum OffCycleReasonTypeEnum {
  notDefined = 0,
  missedPayment = 1,
  other = 2,
  terminationPay = 3,
  onLeavePay = 4,
}

export enum LumpsumTypeEnum {
  notDefined = 0,
  bonusPayment = 1,
  severancePayment = 2,
}

export enum PaydateWeekendAdjustmentTypeEnum {
  notDefined = 0,
  fridayBefore = 1,
  mondayAfter = 2,
}

export enum PaydateHolidayAdjustmentTypeEnum {
  notDefined = 0,
  businessDayBeforeHoliday = 1,
  businessDayAfterHoliday = 2,
}

export enum MonthlyEndDatePatternTypeEnum {
  notDefined = 0,
  lastDateOfMonth = 1,
  thirtyDaysFromStartDate = 2,
}

export enum PayrollAdjustmentTypeEnum {
  notDefined = 0,
  payAdjustment = 1,
  taxAdjustment = 2,
}

export enum PayrollAdjustmentStateTypeEnum {
  notDefined = 0,
  openForDataEntry = 1,
  approved = 2,
  processed = 3,
}

export enum PayPeriodTypeEnum {
  notDefined = 0,
  normal = 1,
  adjustment = 2,
}

export enum PeriodFlags {
  none = 0,
  monthPeriod1 = 1,
  monthPeriod2 = 2,
  monthPeriod3 = 4,
  monthPeriod4 = 8,
  monthPeriod5 = 16,
}

export enum VersionTypeEnum {
  notDefined = 0,
  field = 1,
}

export enum PayPeriodFriendlyStatusTypeEnum {
  notDefined = 0,
  notApproved = 1,
  approved = 2,
  finalized = 3,
  deleted = 4,
  submitted = 5,
}

export enum PayPeriodDocumentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  payPeriodMatrix = 2,
  payPeriodInvoice = 3,
  payrollRegister = 4,
  payrollJournal = 5,
  payrollTaxes = 6,
  payrollIncome = 7,
  payrollBenefit = 8,
  payrollDeduction = 9,
  payrollPayStub = 10,
  payrollDeposit = 11,
  payrollRegisterAdjustment = 12,
  payrollTaxAdjustment = 13,
  payStubAdjustment = 14,
  incomeAdjustment = 15,
  benefitAdjustment = 16,
  deductionAdjustment = 17,
  payrollCompensation = 18,
  payrollCompensationAdjustment = 19,
}

export enum MatrixTooltipIdEnum {
  notDefined = 0,
  midCycleHire = 1,
  midCycleTerminate = 2,
  midCycleRaise = 4,
  newBrunswickOvertimeHours = 8,
  deductionPercentageAmount = 16,
  vacationPay = 32,
  vacationPayHoursNoCalc = 64,
  midCycleLeave = 128,
  newFoundLandOvertimeHours = 256,
  adjustVacationProTip = 512,
  regularPayAdjustmentInVacapayPay = 1024,
  overwrittenRegularPayAdjustmentInVacapayPay = 2048,
}

export enum JobRangeTypeEnum {
  notDefined = 0,
  full = 1,
  midCycleHire = 2,
  midCycleTerminate = 4,
  midCycleRaise = 8,
  midCycleLeave = 5,
}

export enum SemiMonthlyPayGroupPayPeriodTypeEnum {
  notDefined = 0,
  standard = 1,
  nonstandard = 2,
}

export enum MonthlyPayGroupPayPeriodTypeEnum {
  notDefined = 0,
  standard = 1,
  nonstandard = 2,
  thirteenPayPeriodsYear = 3,
}

export enum AdjustmentPaymentStatusEnum {
  notDefined = 0,
  pending = 1,
  complete = 2,
}

export enum AdjustmentPaymentTypeEnum {
  notDefined = 0,
  credit = 1,
  amountOwed = 2,
}

export enum AccountingSyncStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingEligibility = 2,
  waitingSynchronize = 3,
  synchronized = 4,
  failed = 5,
}

export enum AccountingSyncDocumentFlagEnum {
  undefined = 0,
  postingJournal = 1,
  payrollRegister = 2,
  payrollTaxes = 4,
  invoice = 8,
}

export enum TestDiagnosticTypeEnum {
  tax = 0,
  journalEntry = 1,
  roeXmlFormBoxValues = 2,
}

export enum MemoScopeTypeEnum {
  notDefined = 0,
  company = 1,
  payGroup = 2,
  employee = 3,
  negativeAdjustment = 4,
}

export enum MemoFrequencyTypeEnum {
  notDefined = 0,
  onceOnNextOpenPeriod = 1,
  custom = 2,
}

export enum RoeSatDocumentStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  downloaded = 2,
  uploaded = 3,
  pendingSignature = 4,
  signed = 5,
  revoked = 6,
}

export enum RoeStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  draft = 2,
  review = 3,
  finalized = 4,
  submissionInProgress = 5,
  approved = 6,
  rejected = 7,
  manualCreated = 8,
  submittedManual = 9,
  deleted = 10,
}

export enum RoePaymentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  vacation = 2,
  statutoryHoliday = 3,
  other = 4,
  otherSpecific = 5,
}

export enum RoeSatStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  grant = 2,
  revoke = 3,
  discarded = 4,
}

export enum RoeWorkflowStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pdfGenerated = 2,
  xmlGenerated = 3,
  completed = 4,
}

export enum RoeGroupStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  open = 2,
  atCapacity = 3,
  closed = 4,
}

export enum RoeSeverityTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  error = 2,
  warning = 3,
}

export enum RoeVacationPayReasonTypeEnum {
  notDefined = 0,
  includedWithEachPay = 1,
  noLongerWorking = 2,
  vacationLeavePeriod = 3,
  anniversary = 4,
}

export enum RoePayPeriodTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  weekly = 2,
  biWeekly = 3,
  monthly = 4,
  monthlyNonStandard = 5,
  thirteenPayPeriodsPerYear = 6,
  semiMonthly = 7,
  semiMonthlyNonStandard = 8,
}

export enum RoeVacationPayValidationActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  optional = 2,
  mandatory = 3,
  mustBeBlank = 4,
}

export enum RoeRecallActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  returning = 2,
  notReturning = 3,
  unknown = 4,
}

export enum RoeSatReportStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  fileRejected = 2,
  successfulWithRejections = 3,
  successfulWithoutRejections = 4,
}

export enum RoeSatReportProcessStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  completed = 3,
  failed = 4,
  unknownError = 5,
}

export enum UserActionTypeEnum {
  employeeAddressChange = 1,
  newPayrollRun = 2,
}

export enum TaxTableTypeEnum {
  notSpecified = 0,
  rate = 1,
  claim = 2,
  otherRate = 3,
  pension = 4,
  ei = 5,
  constant = 6,
}

export enum TaxTableImportStatusTypeEnum {
  notSpecified = 0,
  staging = 1,
  waitingImport = 2,
  imported = 3,
}

export enum TaxTableOtherRateValueTypeEnum {
  isNumeric = 0,
  isBpaf = 1,
  isBpans = 2,
  isBpayt = 3,
  isDash = 4,
  isEmpty = 5,
}

export interface PayPeriodCellInterface {
  employeeId: number;
  jobId: number;
  baseFieldId: number;
  decimalValue?: number;
  ytd?: number;
  previousPeriodValue?: number;
  et?: number;
  payPeriodId: number;
}

export interface PayPeriodEventInterface {
  periodYear: number;
  periodNumber: number;
  payPeriodCycleType: PayPeriodCycleTypeEnum;
  periodMonth: number;
  periodNumberInMonth: number;
  isOffCycle: boolean;
  isSkipped: boolean;
  actualTargetDate?: string;
}

export interface PayPeriodRowInterface {
  employeeId: number;
  jobId: number;
  calendarEventId: number;
  companyId: number;
  includeInPayroll: boolean;
  payGroupId: number;
  isDirectDeposit: boolean;
  payPeriodCells: string;
  employeeFieldLinks: string;
  special7Fields: string;
  revision: number;
  jobRevision: number;
  employeeRevision: number;
  employeeTaxSettingsRevisions: string;
  initialJobRevision: number;
  initialEmployeeRevision: number;
  initialEmployeeTaxSettingsRevisions: string;
  updatedDate: string;
  updatedBy: string;
  isDepositStopped: boolean;
  stopDepositDate?: string;
  isDepositRejected: boolean;
  jobRangeTypeId: number;
  payEffectiveDate?: string;
  additionalTaxCells: string;
  overrideTaxCells: string;
  jobHourlyRate: number;
  relevantStateId?: number;
  isDeleted: boolean;
  wcbRateId?: number;
  compensationId: number;
  compensationRevision: number;
  initialCompensationRevision: number;
  periodId: number;
  overridenEmployeeFieldIdList: string;
  vacationBalanceHours: number;
  vacationEarnedHours: number;
  vacationEarned: number;
  vacationBalance: number;
  isSkipped: boolean;
  contractorSalesTaxName: string;
  netPay: number;
  wcbStateId?: number;
  jobStateId?: number;
  hasRegularPayAdjustmentInVacapayPayOverwritten: boolean;
  taxableEarnings: number;
}

export interface PayPeriodDocumentInterface {
  documentId: number;
  payPeriodDocumentTypeId: number;
}

export interface PayrollActionHistoryInterface {
  payrollActionTypeId: number;
  actionDate: string;
}

export interface PayPeriodSummaryInterface {
  payGroupName: string;
  startDate: string;
  endDate: string;
  payDate: string;
  cancelCutOffDate: string;
  collectedFromCompany: number;
  employeeCount: number;
  taxAmount: number;
  directDepositCount: number;
  directDepositAmount: number;
  checkCount: number;
  checkAmount: number;
  employeeTax: number;
  employerTax: number;
}

export interface PayPeriodRegisterInterface {
  employeeRevisionKey: string;
  fieldName: string;
  fieldType: number;
  currentHours?: number;
  currentAmount?: number;
  ytdHours?: number;
  ytdAmount?: number;
  departmentId: number;
  jobId: number;
  contributionType: number;
  taxEmployerAmount?: number;
  taxEmployeeAmount?: number;
  taxYtdEmployeeAmount?: number;
  taxYtdEmployerAmount?: number;
}

export interface EmployeeFieldInterface {
  id: number;
  baseFieldId: number;
  jobId: number;
  employeeId?: number;
  frequencyType: FrequencyTypeEnum;
  dataValueType: DataValueTypeEnum;
  decimalValue: number;
  payPeriodId: number;
  ytdMax?: number;
  ytdActionTypeId: number;
  min?: number;
  max?: number;
  variance?: number;
  customPeriodFlags: string;
  isDeleted: boolean;
  revision: number;
  startingCalendarEventId?: number;
  garnishAmount?: number;
  garnishMax?: number;
  garnishYearMax?: number;
  garnishBeginBalance?: number;
  garnishExemption?: number;
  garnishDataValueId?: number;
  correlationKey?: string;
  garnishExemptDataValueTypeId?: number;
  preVolDeductions?: boolean;
  priority?: number;
  salesTaxId?: number;
  ytdMaxDouble?: number;
}

export interface PayPeriodVersionInterface {
  versionType: number;
  primaryKey: number;
  revision: number;
}

export interface Special7FieldInterface {
  explicitFieldTypeId: number;
  baseFieldId: number;
}

export interface PayGroupInterface {
  id: number;
  name: string;
  companyId: number;
  calendarId?: number;
  payPeriodTemplateId?: number;
  payGroupStatusType: PayGroupStatusTypeEnum;
  payrollFrequencyType: PayGroupFrequencyTypeEnum;
  isAutoRun: boolean;
  canEditFrequencySetting: boolean;
  createdBy: string;
  createdDate: string;
  updatedBy?: string;
  updatedDate?: string;
  calendarOwnerType: number;
  auroRunInitialCalendarEventId?: number;
  autoRunModfiedDate?: string;
  payGroupSetting: PayGroupSettingInterface;
  payPeriodList: Array<PayPeriodInterface>;
}

export interface PayGroupSettingInterface {
  weeklyHour: number;
  hoursPerPayPeriod: number;
  startPayPeriodId: number;
  totalNumberOfPeriods: number;
  frequencySetting: FrequencySettingInterface;
}

export interface FrequencySettingInterface {
  payGroupSetting: PayGroupSettingInterface;
  weekly: WeeklyInterface;
  biweekly: BiweeklyInterface;
  semiMonthly: SemiMonthlyInterface;
  monthly: MonthlyInterface;
  quaterly: QuaterlyInterface;
}

export interface BiweeklyInterface {
  startDate?: string;
  payDate?: string;
  endDate?: string;
}

export interface WeeklyInterface {
  startDate?: string;
  payDate?: string;
  endDate?: string;
}

export interface SemiMonthlyInterface {
  paydateWeekendAdjustmentType: PaydateWeekendAdjustmentTypeEnum;
  semiMonthlyPayGroupPayPeriodType: SemiMonthlyPayGroupPayPeriodTypeEnum;
  firstEndDay?: number;
  firstPayDay?: number;
  firstPayDatePatternType: MonthlyEndDatePatternTypeEnum;
  firstEndDatePatternType: MonthlyEndDatePatternTypeEnum;
  secondEndDay?: number;
  secondPayDay?: number;
  secondPayDatePatternType: MonthlyEndDatePatternTypeEnum;
  secondEndDatePatternType: MonthlyEndDatePatternTypeEnum;
}

export interface MonthlyInterface {
  endDay?: number;
  payDay?: number;
  isWithinCycle?: boolean;
  paydateWeekendAdjustmentType: PaydateWeekendAdjustmentTypeEnum;
  paydateBankingHolidayAdjustmentType: PaydateHolidayAdjustmentTypeEnum;
  monthlyPayGroupPayPeriodType: MonthlyPayGroupPayPeriodTypeEnum;
  endDatePatternType: MonthlyEndDatePatternTypeEnum;
  payDatePatternType: MonthlyEndDatePatternTypeEnum;
}

export interface PayPeriodInterface {
  id: number;
  calendarEventId: number;
  startDate: string;
  endDate: string;
  payDate: string;
  processingDate: string;
  payPeriodCalendarStateType: PayPeriodCalendarStateTypeEnum;
  isActualPayDate: boolean;
  periodNumber: number;
  payGroupName: string;
  isAutoRun: boolean;
  payGroupFrequencyType: string;
  actualPayDate?: string;
}

export interface QuaterlyInterface {
  startDate?: string;
  payDate?: string;
  endDate?: string;
  paydateWeekendAdjustmentType: PaydateWeekendAdjustmentTypeEnum;
  paydateBankingHolidayAdjustmentType: PaydateHolidayAdjustmentTypeEnum;
}

export interface PayrollAdjustmentInterface {
  id: number;
  employeeId: number;
  payGroupId: number;
  previousPayPeriodId: number;
  postPayPeriodId?: number;
  payrollAdjustmentType: PayrollAdjustmentTypeEnum;
  payrollAdjustmentStateType: PayrollAdjustmentStateTypeEnum;
  memoId?: number;
  adjustmentList: Array<AdjustmentInterface>;
}

export interface AdjustmentInterface {
  id: number;
  jobId: number;
  hoursFieldId?: number;
  amountFieldId: number;
  previousHours?: number;
  previousAmount?: number;
  adjustedHours?: number;
  adjustedAmount?: number;
  updatedHours?: number;
  updatedAmount?: number;
  ytdAmount?: number;
  ytdHours?: number;
}

export interface PayGroupAutoRunInterface {
  autoRunModfiedDate: string;
  auroRunInitialCalendarEventId: number;
  autorunPeriodNumber: number;
}

export interface PayPeriodTaxAgencyInterface {
  baseFieldId: number;
  taxAgencyId: number;
  employeeId: number;
  stateId: number;
  taxAccountNumber: string;
  taxName: string;
}

export interface TestDiagnosticsInterface {
  companyId: number;
  payPeriodId: number;
  startDate: string;
  endDate: string;
  targetPayDate: string;
  json: string;
  testDiagnosticTypeId: number;
}

export interface PayStubMemoInterface {
  id: number;
  companyId: number;
  memoScopeType: MemoScopeTypeEnum;
  memoFrequencyType: MemoFrequencyTypeEnum;
  memo: string;
  correlationKey?: string;
  includeOffCycle?: boolean;
  payGroupId?: number;
  payDateFrom?: string;
  payDateTo?: string;
  isDeleted: boolean;
  effectiveDeleteDate?: string;
  calendarEventIdList?: string;
  employeeId?: number;
  memoScopeTypeId?: number;
  memoFrequencyTypeId?: number;
  isGroupMemo: boolean;
}

export interface CalendarPayPeriodEventInterface {
  c: number;
  pp?: number;
  pg?: number;
}

export interface RoeSatPersonInterface {
  id: number;
  personId?: number;
  isSignatory: boolean;
  isPrimaryContact: boolean;
  firstName: string;
  lastName: string;
  email: string;
  occupation: string;
  phone: string;
  languageTypeId: number;
  revision: number;
}

export interface RoePayPeriodInterface {
  periodNumber: number;
  endDate?: string;
  insurableEarnings: number;
  insurableHours: number;
  isOverride: boolean;
  roePayPeriodDetailListJson: string;
}

export interface RoePaymentInterface {
  startDate?: string;
  endDate?: string;
  amount?: number;
  perDay: boolean;
  perWeek: boolean;
  roePaymentTypeId: number;
  roeVacationPayReasonTypeId: number;
  code: string;
  baseFieldId?: number;
  roeOtherMoniesCodeId?: number;
  roeOtherSpecificPaymentCodeId?: number;
  isFirstPayPeriod: boolean;
  period: string;
  isOtherMoneyInsurable?: boolean;
}

export interface RoeSerialNumberInterface {
  lowerLimit: string;
  upperLimit: string;
  nextAvailable: string;
  exhaustionMailSent: boolean;
}

export interface RoeIncomeCodeInterface {
  code: string;
  description: string;
  isInsurable: string;
  errorNumber: string;
}

export interface RoeErrorInterface {
  roeId: number;
  roeSubmittedRevision: number;
  code: string;
  info: string;
  description: string;
  descriptionFrench: string;
  roeSeverityTypeId: number;
}

export interface RoePayPeriodDetailInterface {
  paymentRk: string;
  baseFieldId?: number;
  roeOtherMoniesCodeId?: number;
  amount: number;
  hours: number;
  isCustomCode: boolean;
  includedIn17c: boolean;
  insurable: boolean;
}

export interface RoeAddendumAgreementInterface {
  formId: number;
  formStatusTypeId: number;
  documentId?: number;
  isDigitallySigned: boolean;
  signatureDate?: string;
  signedDocumentId?: number;
}

export interface RoeXmlInterface {
  transactionXml: string;
  reportXml: string;
  roeSatReportId?: number;
}

export interface RoeEmployeeAddressInterface {
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  postalCode: string;
}

export interface RoeRevisionInterface {
  companyId: number;
  companyRevision: number;
  personId: number;
  personRevision: number;
  wagepointRevision: number;
  documentId?: number;
  occupation: string;
  reportingStart?: string;
  reportingEnd?: string;
  payGroupId: number;
  otherMoniesDescription: string;
  comments: string;
  roePaymentNextNumber: number;
  finalPayPeriodEndDate?: string;
  expectedRecallDate?: string;
  serialNumber: string;
  previousSerialNumber?: string;
  roePayPeriodType: number;
  roeStatusType: number;
  roeWorkflowStatusType: number;
  issuerFirstName: string;
  issuerLastName: string;
  issuerPhoneNumber: string;
  revision: number;
  submittedRevision: number;
  roeRecallActionType: number;
  totalInsurableHours: number;
  lastCompletedStep: number;
  previousDocumentId?: number;
  isPreviouslyRejected: boolean;
  accountNumber: string;
  infoChangedFlag: number;
  totalInsurableEarnings: number;
  roeReasonId?: number;
  roeGroupId?: number;
  roeSatReportId?: number;
}

export interface TaxTableClaimInterface {
  year: number;
  state: string;
  claimCode: string;
  from?: number;
  to?: number;
  tcp: number;
  kip: number;
}

export interface TaxTableRateInterface {
  key: string;
  first: number;
  second: number;
  third: number;
  fourth: number;
  fifth: number;
  sixth: number;
  seventh: number;
  eighth: number;
  state: string;
}

export interface TaxTableEiRateInterface {
  maxInsurable: number;
  eeContributionRate: number;
  erContributionRate: number;
  eeMaxPremium: number;
  erMaxPremium: number;
}

export interface TaxTableOtherRateInterface {
  basicAmount: number;
  indexRate: number;
  lcpRate: number;
  lcpAmount: number;
  cea: number;
  s: number;
  t4ToV1: number;
  v1Rate: number;
  abatement: number;
  surtax: number;
  basicAmountValueTypeId: number;
  indexRateValueTypeId: number;
}

export interface TaxTablePensionRateInterface {
  ympe: number;
  basicExemption: number;
  maxYmce: number;
  eeRate: number;
  eeMax: number;
  selfMax: number;
  ympePreRounding: number;
}

export interface TaxTableToImportInterface {
  documentId: number;
  stateId: number;
  taxTableTypeId: number;
  taxTableImportStatusTypeId: number;
}

export interface TaxTableConstantInterface {
  value: number;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}
